module.exports = __webpack_public_path__ + "img/ENI_80X30.03731e74.png";